module.exports = __webpack_public_path__ + "img/edit-icon.5bd313db.svg";